export enum UserType {
    STUDENT, TEACHER, ENTERPRISE, CMS_ADMIN, ADMIN
    // 0,       1,      2               3       4
}
